<template><small v-if="text" class="task-relative-time" :class="{'text-danger': past}">{{ text }}</small></template>
<script>
import {relativeTime} from '../../../../shared/taskRelativeTime';
export default {
    props: {value: [String, Date], kind: {type: String, default: 'date'}, full: Boolean},
    data: () => ({now: new Date()}),
    computed: {text() { return relativeTime(this.$moment, this.value, this.now, this.kind, this.full); }, past() { return this.value && new Date(this.value) < this.now; }},
    mounted() { this.tick = () => { this.now = new Date(); }; this.timer = setInterval(this.tick, 30000); document.addEventListener('visibilitychange', this.tick); },
    beforeDestroy() { clearInterval(this.timer); document.removeEventListener('visibilitychange', this.tick); }
};
</script>
<style scoped>.task-relative-time { display:block; font-size:.78rem; color:#526c80; margin-top:3px; }</style>
